import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=7fb10be2&scoped=true&"
import script from "./FormData.vue?vue&type=script&lang=js&"
export * from "./FormData.vue?vue&type=script&lang=js&"
import style0 from "./FormData.vue?vue&type=style&index=0&id=7fb10be2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb10be2",
  null
  
)

export default component.exports